<template>
  <table class="key-value-table">
    <tbody>
      <slot></slot>
    </tbody>
  </table>
</template>

<script>
export default {

}
</script>

<style lang="scss">
.key-value-table {
  display: block;
  width: 100%;

  @include media(small) {
    display: table;
    border-collapse: collapse;
  }
}

.key-value-table tbody {
  display: contents;

  @include media(small) {
    display: table-row-group;
  }
}
</style>
